<template>
  <ContentCardSubheader :back-to="{ name: ReviewsRouteName.ReviewsAgenciesIndex }">
    {{ t('Reviews.agency.view.traitsTitle', { agencyName: agency.title }) }}
    <template #actions>
      <RouterLink
        class="btn-primary-color-s"
        data-testid="edit-button"
        :to="{ name: ReviewsRouteName.ReviewsAgencyEditTraits, params: { agencyId: agency.id } }"
        @click="track('profile_update_start', { surface: 'editor', entity_type: 'service', entity_id: agency.id })"
      >
        {{ t('Reviews.edit.action.edit') }}
      </RouterLink>
    </template>
  </ContentCardSubheader>
</template>
<script setup lang="ts">
import { track } from '@ramp106/omrjs-tracking-reviews'
import { useI18n } from 'vue-i18n'

import type { AgencyById } from '@/gql/reviews'
import { ReviewsRouteName } from '@/router/types'
import ContentCardSubheader from '@/ui/ContentCardSubheader.vue'

defineProps<{
  agency: Pick<AgencyById, 'id' | 'title' | 'traits'>
}>()

const { t } = useI18n()
</script>
